import React, { useMemo } from "react";
// CSS
import { Button, Dimmer, Loader } from "semantic-ui-react";

// Interface
import {
  Event as MobEvent,
  State as MobState,
} from "../../../../patient-lib/MobTransformInterface";

// UI
import TFHead from "./TFHead";
import { PersonalInformation } from "./TFRegister";
import ModMessage from "./ModMessage";

type TFEditProfileProps = {
  onEvent: (e: MobEvent) => any;
  history: any;
} & Pick<
  MobState,
  "loadingMainTransform" | "successMessage" | "errorMessage" | "registerInfo"
>;

const initialHeight = window.innerHeight;

const TFEditProfile: React.FunctionComponent<TFEditProfileProps> = (props) => {
  const contentHeight = useMemo(() => {
    return `${(initialHeight * 63) / 100}px`;
  }, []);

  /* ----------------------- Handle ----------------------- */
  const handleLeftIconClick = () => {
    props.history.goBack();
  };

  const handleUpdatePatientProfile = () => {
    props.onEvent({
      message: "UpdatePatientProfile",
      params: { history: props.history, current: "info" },
    });
  };

  return (
    <div className="tf-register">
      <Dimmer
        active={props.loadingMainTransform}
        inverted
        style={{ zIndex: 1100 }}
      >
        <Loader inverted>Loading</Loader>
      </Dimmer>

      <TFHead title={"ข้อมูลส่วนตัว"} leftIconClick={handleLeftIconClick} />

      <div className="tf-main">
        <PersonalInformation
          {...props}
          onSubmit={handleUpdatePatientProfile}
          height={contentHeight}
        />
        <Button
          fluid
          className="button-submit-primary"
          onClick={handleUpdatePatientProfile}
        >
          บันทึก
        </Button>
      </div>

      <ModMessage
        onEvent={props.onEvent}
        successMessage={props.successMessage}
        errorMessage={props.errorMessage}
      />
    </div>
  );
};

TFEditProfile.defaultProps = {
  onEvent: () => {},
  history: {},
} as TFEditProfileProps;

export default TFEditProfile;
